import { createFormErrorMapper, ZodIssueMap } from '@/common/form/utils.ts';
import { useFieldContext } from '@/lib/form.ts';
import { useStore } from '@tanstack/react-form';
import { uniq } from 'es-toolkit';

export interface FormFieldErrorsProps {
  zodIssueMap?: ZodIssueMap;
}

export const FormFieldErrors = ({ zodIssueMap }: FormFieldErrorsProps) => {
  const field = useFieldContext();
  const errors = useStore(field.store, (state) => state.meta.errors);

  const mapFormError = createFormErrorMapper(zodIssueMap ?? {});

  return uniq(errors.map(mapFormError)).map((err, idx) => (
    <span key={idx} data-testid={`${field.name}-error`} role="alert" className="block">
      {err}
    </span>
  ));
};
